import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "flex between" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "flex between align-c" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "flex align-c" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "radial-btn-container" }, null, -1)
const _hoisted_7 = ["title"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "Tech Notes", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h2", { class: "header" }, "Features", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GithubLinks = _resolveComponent("GithubLinks")!
  const _component_ImageDisplay = _resolveComponent("ImageDisplay")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.projectDetailContainer)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["page-header", _ctx.$style.projectDetailHeader])
      }, [
        _createElementVNode("div", {
          class: _normalizeClass([_ctx.$style.projectNameContainer, "flex between align-c"])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["header", _ctx.$style.projectName])
          }, _toDisplayString(_ctx.project?.name), 3),
          (_ctx.isMobileView)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "btn-danger",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleNavigateBack && _ctx.handleNavigateBack(...args)))
              }, "back"))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            class: "btn-radial-responsive",
            href: _ctx.project.url,
            target: "_blank"
          }, "Visit Site", 8, _hoisted_3),
          _createElementVNode("div", {
            class: _normalizeClass([_ctx.$style.githubLinksContainer, "flex between"])
          }, [
            _createVNode(_component_GithubLinks, {
              "front-end-link": _ctx.project.github.frontEnd,
              "back-end-link": _ctx.project.github.backEnd
            }, null, 8, ["front-end-link", "back-end-link"])
          ], 2)
        ]),
        (!_ctx.isMobileView)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "btn-danger",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleNavigateBack && _ctx.handleNavigateBack(...args)))
            }, "back"))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.$style.projectDescription)
        }, _toDisplayString(_ctx.project?.description), 3)
      ]),
      _hoisted_5
    ]),
    _hoisted_6,
    _createElementVNode("div", {
      class: _normalizeClass(["flex padded-container-1", _ctx.$style.projectImagesContainer])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.images, (url) => {
        return (_openBlock(), _createBlock(_component_ImageDisplay, {
          key: url,
          "image-url": url,
          "image-height": _ctx.isMobileView ? '8em' : '20em',
          "hover-zoom": true,
          "click-zoom": true,
          "image-class": 'imageElementWithHover'
        }, null, 8, ["image-url", "image-height"]))
      }), 128))
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$style.techContainer)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.tech, (skill) => {
        return (_openBlock(), _createElementBlock("i", {
          key: skill.name,
          class: _normalizeClass(["size-2andhalfem m-quarter", 'devicon-' + skill.styleTag]),
          title: skill.name
        }, null, 10, _hoisted_7))
      }), 128))
    ], 2),
    _createElementVNode("ul", {
      class: _normalizeClass(_ctx.$style.techNotesContainer)
    }, [
      _hoisted_8,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.notes, (note) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "m-b-1",
          key: note
        }, _toDisplayString(note), 1))
      }), 128))
    ], 2),
    _createElementVNode("ul", {
      class: _normalizeClass(_ctx.$style.featuresList)
    }, [
      _hoisted_9,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.project.features, (feature) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "m-b-1",
          key: feature
        }, _toDisplayString(feature), 1))
      }), 128))
    ], 2)
  ], 2))
}